import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/product-movements', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const searchProduct = (Options = {}) => {
  return httpClient
    .get('/api/product-movements/search-products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const excel = (Options = {}) => {
  return httpClient
    .get('/api/product-movements/excels', Object.assign(Options,{
      responseType: 'arraybuffer'
    }))
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get, excel, searchProduct
}
